import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import styles from "./KycResend.module.css";
import Lottie from "lottie-react";
import Thumsup from "../Notification/Thumsup.json";
import companyStore from "../../../Store/Store";

const KycResend = ({ isVisible, onClose, className = "" }) => {
  const navigate = useNavigate();

  const onXCircleIconClick = useCallback(() => {
    navigate("/content/users");
  }, [navigate]);

  if (!isVisible) return null;
  return (
    <div
      className={[styles.frameParent, className].join(" ")}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div className={styles.containerNotifi}>
        <div className={styles.xCircleWrapper}>
          <img
            className={styles.xCircleIcon}
            alt=""
            src="/xcircle1.svg"
            onClick={onClose}
          />
        </div>
        <div className={styles.httpslottiefilescomanimatParent}>
          <Lottie
            className={styles.httpslottiefilescomanimatIcon}
            animationData={Thumsup}
            loop={true}
          />
          <div className={styles.userAddedSuccessfully}>
            KYC Link Resent to the User Email ID
          </div>
        </div>
        {companyStore.userType == "PineLabUser" && (
          <div className={styles.finalCupiLogo}>
            <img className={styles.escrowLogo} alt="" src="/PineLabsLogo.svg" />
          </div>
        )}
      </div>
    </div>
  );
};

KycResend.propTypes = {
  className: PropTypes.string,
};

export default KycResend;
